// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-connect-container {
  margin: 20px;
}

.data-connect-container h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #232323;
  font-weight: 600;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.data-connect-container .beta-badge {
  background-color: #5616ea;
  color: white;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  top: -4px;
}

.data-connect-container > p {
  color: #666;
  margin-bottom: 2rem;
  font-size: 1rem;
}

.data-info-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #5616ea25;
  border-radius: 10px;
  padding: 14px;
  line-height: 1.45;
  border-left: 5px solid #5616ea;
  max-width: 900px;
}

.data-info-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.data-info-box p {
  margin: 0;
}

.data-info-icon {
  font-size: 32px;
  color: #5616ea;
  flex-shrink: 0;
}

.data-platforms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 1.5rem;
  align-items: stretch;
}

.data-platform-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  padding-top: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  position: relative;
}

.data-platform-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.data-platform-card.coming-soon {
  opacity: 0.7;
}

.data-platform-card.coming-soon:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.data-platform-card .coming-soon-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: #9e9e9e;
  color: white;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.data-platform-card .platform-card-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: flex-end;
}

.data-platform-card .platform-icon {
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
}

.data-platform-card .platform-icon.google-drive {
  color: #4285f4;
}

.data-platform-card .platform-icon.notion {
  color: #000;
}

.data-platform-card .platform-icon.onedrive {
  color: #0078D4;
}

.data-platform-card h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.data-platform-card p {
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
  line-height: 1.5;
}

.data-platform-card .connected-success {
  background-color: #f3eaff;
  color: #3d0d99;
  padding: 10px 16px;
  border-radius: 12px;
  font-weight: 600;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  text-align: center;
  border-left: 4px solid #5616ea;
}

.data-platform-card .button-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}

.data-connect-container .connected-accounts {
  margin-top: 1.5rem;
  text-align: left;
  border-top: 1px solid #eee;
  padding-top: 1rem;
}

.data-connect-container .connected-accounts h4 {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.data-connect-container .connected-account-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 0.5rem;
}

.data-connect-container .connected-account-item:last-child {
  margin-bottom: 0;
}

.data-connect-container .account-info {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-connect-container .disconnect-button {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.data-connect-container .disconnect-button:hover {
  background-color: #fee2e2;
}

/* Ensure not-allowed cursor shows for disabled manage buttons */
.data-connect-container .disabled-button-wrapper {
  display: block;
  width: 100%;
  cursor: not-allowed;
}

.data-connect-container .disabled-button-wrapper .MuiButton-root.Mui-disabled {
  pointer-events: none;
}

@media (max-width: 768px) {
  .data-platforms-grid {
    grid-template-columns: 1fr;
  }

  .data-connect-container h2 {
    font-size: 1.7rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/DataConnect.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".data-connect-container {\r\n  margin: 20px;\r\n}\r\n\r\n.data-connect-container h2 {\r\n  font-size: 2rem;\r\n  margin-bottom: 1rem;\r\n  color: #232323;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.data-connect-container .beta-badge {\r\n  background-color: #5616ea;\r\n  color: white;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  padding: 4px 8px;\r\n  border-radius: 8px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  position: relative;\r\n  top: -4px;\r\n}\r\n\r\n.data-connect-container > p {\r\n  color: #666;\r\n  margin-bottom: 2rem;\r\n  font-size: 1rem;\r\n}\r\n\r\n.data-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #5616ea25;\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #5616ea;\r\n  max-width: 900px;\r\n}\r\n\r\n.data-info-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.data-info-box p {\r\n  margin: 0;\r\n}\r\n\r\n.data-info-icon {\r\n  font-size: 32px;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.data-platforms-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 2rem;\r\n  margin-top: 1.5rem;\r\n  align-items: stretch;\r\n}\r\n\r\n.data-platform-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  padding-top: 1rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  text-align: center;\r\n  transition: box-shadow 0.2s;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n}\r\n\r\n.data-platform-card:hover {\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.data-platform-card.coming-soon {\r\n  opacity: 0.7;\r\n}\r\n\r\n.data-platform-card.coming-soon:hover {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.data-platform-card .coming-soon-badge {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  background-color: #9e9e9e;\r\n  color: white;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  padding: 4px 8px;\r\n  border-radius: 8px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.data-platform-card .platform-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.data-platform-card .platform-icon {\r\n  margin: 0 auto 1.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 4rem;\r\n}\r\n\r\n.data-platform-card .platform-icon.google-drive {\r\n  color: #4285f4;\r\n}\r\n\r\n.data-platform-card .platform-icon.notion {\r\n  color: #000;\r\n}\r\n\r\n.data-platform-card .platform-icon.onedrive {\r\n  color: #0078D4;\r\n}\r\n\r\n.data-platform-card h3 {\r\n  font-size: 1.5rem;\r\n  color: #333;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.data-platform-card p {\r\n  color: #666;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.data-platform-card .connected-success {\r\n  background-color: #f3eaff;\r\n  color: #3d0d99;\r\n  padding: 10px 16px;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n  font-size: 0.9rem;\r\n  text-align: center;\r\n  border-left: 4px solid #5616ea;\r\n}\r\n\r\n.data-platform-card .button-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n  width: 100%;\r\n}\r\n\r\n.data-connect-container .connected-accounts {\r\n  margin-top: 1.5rem;\r\n  text-align: left;\r\n  border-top: 1px solid #eee;\r\n  padding-top: 1rem;\r\n}\r\n\r\n.data-connect-container .connected-accounts h4 {\r\n  font-size: 0.9rem;\r\n  color: #666;\r\n  margin-bottom: 0.75rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.data-connect-container .connected-account-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 12px;\r\n  background-color: #f8f9fa;\r\n  border-radius: 8px;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.data-connect-container .connected-account-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.data-connect-container .account-info {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 0.9rem;\r\n  color: #333;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.data-connect-container .disconnect-button {\r\n  background: none;\r\n  border: none;\r\n  color: #dc3545;\r\n  cursor: pointer;\r\n  padding: 6px 10px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.data-connect-container .disconnect-button:hover {\r\n  background-color: #fee2e2;\r\n}\r\n\r\n/* Ensure not-allowed cursor shows for disabled manage buttons */\r\n.data-connect-container .disabled-button-wrapper {\r\n  display: block;\r\n  width: 100%;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.data-connect-container .disabled-button-wrapper .MuiButton-root.Mui-disabled {\r\n  pointer-events: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .data-platforms-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .data-connect-container h2 {\r\n    font-size: 1.7rem;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
